<section
  style="
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    flex-direction: column;
  "
>
  <h1 style="font-size: 250px; line-height: 250px; margin: 0px">404</h1>
  <h2>Something just happened that wasn't happy!</h2>
</section>
